import { anyPass, isNil, isEmpty, pipe, values, any } from "ramda";

export const isEmptyOrNull = anyPass([isNil, isEmpty]);

export const hasNullField = pipe(
  values, // Get all values from the object
  any(isNil) // Check if any value is null or undefined
);
